import type { CapturedNetworkRequest } from "posthog-js";

/** Replay must never record clinical envelopes, attachment credentials, or auth headers.
 * Installing a callback replaces PostHog's body/header masking, so preserve that
 * protection for every other request while retaining nonclinical timing data.
 */
export function maskClinicalReplayRequest(
  request: CapturedNetworkRequest,
): CapturedNetworkRequest | null {
  if (/\/master-product(?:\/|-intake)|\/(?:documents|attachments)(?:\/|$)|\/storage\/v1\/object\/sign\//.test(request.name))
    return null;
  const {
    requestBody: _requestBody,
    responseBody: _responseBody,
    requestHeaders: _requestHeaders,
    responseHeaders: _responseHeaders,
    ...metadata
  } = request;
  // The SDK also uses this callback for replay page URLs. Strip credentials
  // from the captured copy without changing navigation or replay interactions.
  const name = metadata.name.split(/[?#]/, 1)[0];
  try {
    const url = new URL(name, "https://replay.invalid");
    if (/^\/guides(?:\/|$)/i.test(decodeURIComponent(url.pathname))) {
      return { ...metadata, name: name.startsWith("/") ? "/guides/[redacted]" : `${url.origin}/guides/[redacted]` };
    }
  } catch {
    return null;
  }
  return { ...metadata, name };
}
